import { io } from 'socket.io-client';
import { API_URL } from '../config/constants';


class SocketService {
    constructor() {
        this.socket = null;
        this.listeners = new Map();
    }

    connect() {
        this.socket = io(API_URL, {
            withCredentials: true,
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: 5
          
        });

        this.socket.on('connect', () => {
            console.log('Connected to notification service');
        });

        this.socket.on('connect_error', (error) => {
            console.error('Socket connection error:', error);
        });

        this.socket.on('incident:created', (payload) => {
            this.notifyListeners('incident:created', payload);
        });

        this.socket.on('smsincident:created', (payload) => {
            this.notifyListeners('smsincident:created', payload);
        });

        this.socket.on('whatsappincident:created', (payload) => {
            this.notifyListeners('whatsappincident:created', payload);
        });

        this.socket.on('monitorincident:created', (payload) => {
            this.notifyListeners('monitorincident:created', payload);
        });

        this.socket.on('portalincident:created', (payload) => {
            this.notifyListeners('portalincident:created', payload);
        });
    }

    addListener(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(callback);
        return () => {
            const callbacks = this.listeners.get(event);
            if (callbacks) {
                callbacks.delete(callback);
            }
        };
    }

    notifyListeners(event, data) {
        const callbacks = this.listeners.get(event);
        if (callbacks) {
            callbacks.forEach(callback => callback(data));
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export default new SocketService();